import React, { Component, Fragment } from "react"
import { Content, Grid } from "../../components/Layout"
import Header from "../../components/Header"
import Sidebar from '../../components/Sidebar'
import ContentHeader from '../../components/ContentHeader'
import dateToBrFormat from '../../utils/dateToBrFormat'
import styled from "styled-components"
import { color, productFullName, pxToRem } from "../../utils"
import { connect } from "react-redux"
import { certificateControlActions, productMapActions } from "../../actions"
import statusSuccess from '../../assets/icons/status-success.svg'
import statusDanger from '../../assets/icons/status-danger.svg'
import statusWarning from '../../assets/icons/status-warning.svg'
import iconExcel from '../../assets/icons/iconExcel.svg'
import DataTable from "../../components/Table/Table"
import { ProductMapModal } from "../../components/ProductModal"
import { CaptionsCertificateControl } from "../../components/CaptionsCertificateControl"
import { DownloadButton } from "../../components/Form"
import Modal from "../../components/Modal"

// criar componentes pois são utilizados em product map
const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: ${pxToRem(10)};
`

const ProductMapLink = styled.a`
  color: ${color.secondary};
  text-transform: uppercase;
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
`

const WrapperStatus = styled.div`
  width: 20px;
  height: 20px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: relative;

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    margin: auto;
    width: 14px;
    height: 14px;
  }

  ${({ type }) => {
    return `background: ${type === 'n' ? color.danger : type === 's' ? color.success : color.warning}`
  }};
`

const WrapperDownload = styled.div`
  display: block;
  text-align: right;
  width: 100%;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    img {
      margin-right: 2px;
      max-width: 14px;
      max-height: 14px;
    }
  padding-left: 0;
  padding-right: 0;
  }
  span {
    font-weight: bold;
  }
`

const ExpiredDate = styled.p`
  color: red;
  font-weight: bold;
`

const plural = (text, ...args) => {
  const [qtd = '--'] = args;

  const formattedText = text.map((item, index) => {
    const singular = index === 0;

    switch (true) {
      case qtd === 0:
        return singular ? 'Não existem ' : item;
      case qtd === 1:
        return singular ? `Existe no total ${qtd} ${item}` : 'produto com certificado nesta área';
      default:
        return singular ? `Existem no total ${qtd} ${item}` : item;
    }
  });

  return formattedText;
}


const columns = {
  id: {
    hide: true
  },
  name: {
    label: 'Produto',
    sortable: true,
    align: 'left',
    width: pxToRem(150)
  },
  provider: {
    label: 'Fornecedor',
    sortable: true,
    align: 'left',
    width: pxToRem(50)
  },
  certificate_halal_path: {
    label: 'Certificado Halal',
    sortable: false,
    align: 'center',
    width: pxToRem(50)
  },
  certificate_halal_expiring_date: {
    label: 'Data de vigência Halal',
    sortable: false,
    align: 'left',
    width: pxToRem(50)
  },
  certificate_halal_status: {
    hide: true
  },
  certificate_kosher_path: {
    label: 'Certificado Kosher',
    sortable: false,
    align: 'center',
    width: pxToRem(50)
  },
  certificate_kosher_expiring_date: {
    label: 'Data de vigência Kosher',
    sortable: false,
    width: pxToRem(50),
    align: 'left'
  },
  certificate_kosher_status: {
    hide: true
  }
}

class CertificateControl extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openProductMapModal: false,
      debounce: undefined,
      productMapStatusError: false
    }
  }

  componentDidMount() {
    this.props.fetchCertificateControls(this.props.areaId)
  }

  componentDidUpdate(prevProps) {
    if (this.props.areaId && prevProps.areaId !== this.props.areaId) {
      const debounce = setTimeout(() => {
        this.props.fetchSearch(this.props.searchText, this.props.areaId)
      }, 400)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }
  }

  componentWillUpdate({ searchText = '' }) {
    if (searchText !== this.props.searchText) {
      const debounce = setTimeout(() => {
        this.props.fetchSearch(searchText, this.props.areaId)
      }, 400)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  onChangeRowsPerPage = (rowsPerPage, currentPage = 1) => {
    if (!!this.props.searchText) {
      this.props.fetchSearch(this.props.searchText, this.props.areaId, currentPage, rowsPerPage, this.props.pagination.order_by, this.props.pagination.order ? "asc" : "desc")
    } else {
      this.props.fetchCertificateControls(this.props.areaId, currentPage, rowsPerPage, this.props.pagination.order_by, this.props.pagination.order ? "asc" : "desc")
    }
  }

  onChangePage = (newPage, rowsPerPage) => {
    if (!!this.props.searchText) {
      this.props.fetchSearch(this.props.searchText, this.props.areaId, newPage, rowsPerPage, this.props.pagination.order_by, this.props.pagination.order ? "asc" : "desc")
    } else {
      this.props.fetchCertificateControls(this.props.areaId, newPage, rowsPerPage, this.props.pagination.order_by, this.props.pagination.order ? "asc" : "desc")
    }
  }

  onChangeOrderBy = (orderBy, order, currentPage = 1, rowsPerPage = 10) => {
    if (orderBy === "has_incompatibility") orderBy = "incompatibility"
    if (!!this.props.searchText) {
      this.props.fetchSearch(this.props.searchText, this.props.areaId, currentPage, rowsPerPage, orderBy, order)
    } else {
      this.props.fetchCertificateControls(this.props.areaId, currentPage, rowsPerPage, orderBy, order)
    }
  }

  openModal = (e, id) => {
    e.preventDefault()
    this.props.fetchProductMap(id)

    this.setState(state => ({
      openProductMapModal: true
    }))
  }

  closeModal = () => {
    this.setState(state => ({
      openProductMapModal: false
    }))
  }

  downloadXls = () => {
    this.props.fetchDownloadXls(this.props.searchText, this.props.areaId)
  }

	render() {
		const {
      changeStatusDownloadError,
      fetchCertificateControls,
      pagination,
      fetch_errors,
      fetching,
      last_update,
      menuItems = [],
      certificateControls,
      router,
      total_records,
      canChangeStatus,
      areaId,
      can_change_area,
      loadingDownload
    } = this.props

    const {
      onChangePage,
      onChangeRowsPerPage,
      onChangeOrderBy,
      openModal,
      closeModal,
      downloadXls
    } = this

    const { openProductMapModal, productMapStatusError } = this.state

    const CellComponent = ({ name, value, row, ...rest }) => {
      return (
        <ProductMapLink {...rest} onClick={e => openModal(e, row.id)}>
          {value}
        </ProductMapLink>
      )
    }

    columns['name'] = {
      ...columns['name'],
      CellComponent
    }

    const CertificateComponent = (status, path) => {
      let item = {}
      switch(status) {
        case 'valid':
          item = {
            icon: statusSuccess,
            value: 's'
          }
          break

        case 'expiring':
          item = {
            icon: statusWarning,
            value: 'w'
          }
          break

        default:
          item = {
            icon: statusDanger,
            value: 'n'
          }
          break
      }

      return (
        <WrapperStatus
          data-tip={`Este produto é incompatível com: ${item.tooltip}`}
          type={`${item.value}`}
        >
          {path !== '---' ? (
            <a href={path} target="_blank">
              <span aria-label={item.value}>
                <img src={item.icon} alt={item.value} />
              </span>
            </a>
          ) : (
            <span aria-label={item.value}>
              <img src={item.icon} alt={item.value} />
            </span>
          )}
        </WrapperStatus>
      )
    }

    columns['certificate_halal_path'] = {
      ...columns['certificate_halal_path'],
      CellComponent: ({ row }) =>
        CertificateComponent(row.certificate_halal_status, row.certificate_halal_path)
    }

    columns['certificate_kosher_path']= {
      ...columns['certificate_kosher_path'],
      CellComponent: ({ row }) => CertificateComponent(row.certificate_kosher_status, row.certificate_kosher_path)
    }


		return (
			<Fragment>
				<Grid>
					<Header search router={router} />
					<Sidebar menuItems={menuItems} router={router} />
          <Content scapeSearch>
            <ContentHeader
              title="Produtos com certificados na área"
              subtitle={plural`Existe no total ${total_records} produtos com certificado nesta área`}
              last_update={dateToBrFormat(new Date(last_update))}
            >
            </ContentHeader>
						<Wrapper>
              <CaptionsCertificateControl />

              <WrapperDownload>
                <DownloadButton
                  loading={loadingDownload}
                  onClick={e => {
                    downloadXls()
                  }}
                >
                  <img src={iconExcel} />
                  <span>Exportar para excel</span>
                </DownloadButton>
              </WrapperDownload>
            </Wrapper>

            <DataTable
              loading={fetching.certificateControls}
              error={fetch_errors.certificateControls}
              fetchData={fetchCertificateControls}
              onChangePage={(newPage, rowsPerPage, orderBy, order) =>
                onChangePage(newPage, rowsPerPage, orderBy, order)
              }
              onChangeRowsPerPage={(rowsPerPage, currentPage, orderBy, order) =>
                onChangeRowsPerPage(rowsPerPage, currentPage, orderBy, order)
              }
              onChangeOrderBy={(orderBy, order, currentPage, rowsPerPage) =>
                onChangeOrderBy(orderBy, order, currentPage, rowsPerPage)
              }
              columns={columns}
              height={'55vh'}
              width={1100}
              data={certificateControls.map(item => {
                return {
                  ...item,
                  name: productFullName(item)
                }
              })}
              pagination={pagination || {}}
              defaultSort={{ key: 'name', reverse: false }}
            />
					</Content>
				</Grid>

        <Modal
          safeContent={false}
          loading={false}
          open={fetch_errors.download}
          size={'small'}
          error={true}
          errorMessage={'Falha ao exportar o arquivo'}
          closeMethod={changeStatusDownloadError}
        />

        <ProductMapModal
          open={openProductMapModal}
          closeModal={closeModal}
        />
			</Fragment>
		)
	}
}

const mapStateToProps = state => ({
  certificateControls: state.certificateControl.items,
  total_records: state.certificateControl.total_records,
  last_update: state.certificateControl.last_update,
  pagination: state.certificateControl.pagination,
  fetching: state.certificateControl.fetching,
  fetch_errors: state.certificateControl.fetch_errors,
  searchText: state.search.searchText,
  areaId: state.auth.areaId,
  permissions: state.auth.permissions,
  can_change_area: state.auth.canChangeArea,
  loadingDownload: state.certificateControl.fetching.download
})

const mapDispatchToProps = dispatch => {
  return {
    fetchCertificateControls: (areaId, page, rowsPerPage, orderBy, order) => {
      dispatch(certificateControlActions.fetchCertificateControls(areaId, page, rowsPerPage, orderBy, order))
    },
    fetchProductMap: id => {
      dispatch(productMapActions.fetchProductMap(id))
    },
    fetchSearch: (searchText, areaId, page, rowsPerPage, orderBy, order) => {
      dispatch(certificateControlActions.fetchSearch(searchText, areaId, page, rowsPerPage, orderBy, order))
    },
    fetchDownloadXls: (searchText, areaId) => {
      dispatch(certificateControlActions.fetchDownloadXls(searchText, areaId))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CertificateControl)



// WEBPACK FOOTER //
// ./src/containers/ProductMap/CertificateControl.js